import * as React from "react";
import Clear from "@bolteu/kalep-react-icons/dist/Clear";
import { cx } from "../../helpers/utils/cx";
import { Tooltip } from "../Tooltip";
export function ClearInputButton(_ref) {
  let {
    clearTextLabel,
    onClick,
    size,
    buttonClassname
  } = _ref;
  return /*#__PURE__*/React.createElement(Tooltip, {
    content: clearTextLabel || ""
  }, /*#__PURE__*/React.createElement("button", {
    "aria-label": clearTextLabel,
    className: cx("group/clearbutton border-0 bg-transparent p-1 cursor-pointer", buttonClassname),
    onClick: onClick,
    type: "button"
  }, /*#__PURE__*/React.createElement(Clear, {
    "aria-hidden": "true",
    className: cx("block text-tertiary", "group-hover/clearbutton:text-secondary"),
    size: size
  })));
}